import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { CONSTANTS } from './includes/constant';
import LoginScreen from './screens/login';
import ResetPasswordScreen from './screens/reset_password';
import OTPScreen from './screens/otp';
import DashboardScreen from './screens/dashboard';
import DashboardSection from './screens/dashboard/sections/dashboard';
import TreepzHistorySection from './screens/dashboard/sections/treepz_history';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VehiclesSection from './screens/dashboard/sections/vehicles';
import SettingsScreen from './screens/dashboard/sections/settings';
import CreatePasswordScreen from './screens/create_password';
import BusinessSection from './screens/dashboard/sections/business';
import RolesAndPermissionsSection from './screens/dashboard/sections/rolesAndPermissions';

function App() {
  return (<BrowserRouter>
    <Routes>
      <Route path={CONSTANTS.Routes.Dashboard} element={<DashboardScreen />} >
        <Route path={CONSTANTS.Routes.Businesses} element={<BusinessSection />} />
        <Route path={CONSTANTS.Routes.TreepzHistory} element={<TreepzHistorySection />} />
        <Route path={CONSTANTS.Routes.Vehicles} element={<VehiclesSection />} />
        <Route path={CONSTANTS.Routes.RolesPermissions} element={<RolesAndPermissionsSection />} />
        <Route path={CONSTANTS.Routes.Settings} element={<SettingsScreen />} />
        <Route path={CONSTANTS.Routes.Notification} element={<SettingsScreen />} />
        <Route path={""} element={<DashboardSection />} />
        <Route path={"*"} element={<DashboardSection />} />
      </Route>
      <Route path={CONSTANTS.Routes.Login} element={<LoginScreen />} />
      <Route path={CONSTANTS.Routes.CreateAccount} element={<LoginScreen />} />
      <Route path={CONSTANTS.Routes.ForgotPassword} element={<ResetPasswordScreen />} />
      <Route path={CONSTANTS.Routes.CreatePassword} element={<CreatePasswordScreen />} />
      {localStorage.getItem(CONSTANTS.Routes.ForgotPassword) && <>
        <Route path={CONSTANTS.Routes.Otp} element={<OTPScreen />} />
      </>}
      <Route path={"*"} element={<LoginScreen />} />
    </Routes>
    <ToastContainer />
  </BrowserRouter>);
}

export default App;
